import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import ReactJson from 'react-json-view';
import JobLogStatus from 'components/integrations/JobLogStatus';
import JobLogTypesSelector from 'components/selectors/JobLogTypesSelector';
import JobLobStatusSelector from 'components/selectors/JobLogStatusSelector';
import Table, { useTable } from 'common/components/table';
import BasicModal from 'common/components/modals/BasicModal';

const Crons = ({ topTabs }) => {
  const [activeRow, setRow] = useState({
    open: false,
    value: null
  });
  const table = useTable({
    label: 'crons',
    columns: [
      {
        header: 'Job',
        key: 'job',
        type: 'collection',
        component: JobLogTypesSelector,
        sort: true,
        width: 4
      },
      {
        header: 'Status',
        key: 'status',
        type: 'collection',
        component: JobLobStatusSelector,
        sort: true,
        width: 2
      },
      {
        header: 'Started At',
        key: 'started_at',
        type: 'date',
        sort: true,
        width: 2
      },
      {
        header: 'Finished at',
        key: 'finished_at',
        type: 'date',
        sort: true,
        width: 2
      },
      {
        header: 'Details',
        key: 'details',
        type: 'string',
        sort: false,
        canFilter: false,
        width: 2
      }
    ],
    top: {}
  });

  return (
    <Row className="crons-table">
      <Col xs={12}>
        <Table
          bulk
          bulkActions={[]}
          topFiltersComponent={topTabs}
          loader
          rows={{
            status: data => <JobLogStatus status={data.status} />,
            details: data => (
              <div
                className="cursor-pointer"
                onClick={() => setRow({ open: true, value: data.details })}
              >
                Click for details
              </div>
            )
          }}
          {...table}
        />
      </Col>

      <BasicModal
        isOpen={activeRow.open}
        toggle={() => setRow(!activeRow.open)}
        header="Details"
        className="crons-modal-details"
        body={
          activeRow.value ? (
            <ReactJson
              enableClipboard={false}
              iconStyle="square"
              displayDataTypes={false}
              displayObjectSize={false}
              src={JSON.parse(activeRow.value)}
            />
          ) : null
        }
      />
    </Row>
  );
};

export default Crons;
